import { BloodGroupEnum } from "@gtpl/shared-models/gtpl";
import { Column, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('donors')
export class Donors {
  @PrimaryGeneratedColumn("increment", { name: 'donor_id' })
  donorsId: number;

  @Column("char", {
    nullable: false,
    length: 50,
    name: "donor_name"
  })
  donorName: string;

  @Column("char", {
    nullable: false,
    length: 25,
    name: "phone_no"
  })
  phoneNo: string;

  @Column("char", {
    nullable: false,
    length: 50,
    name: "country"
  })
  country: string;

  @Column("char", {
    nullable: false,
    length: 50,
    name: "state"
  })
  state: string;

  @Column("char", {
    nullable: false,
    length: 50,
    name: "district"
  })
  district: string;

  @Column("char", {
    nullable: false,
    length: 50,
    name: "constituency"
  })
  constituency: string;

  @Column("char", {
    nullable: true,
    length: 25,
    name: "blood_group"
  })
  bloodGroup: string;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

 
}